import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import {
  TOGGLE_PAYER,
  TOGGLE_PROVIDER,
  TOGGLE_MY_ACCOUNT,
  TOGGLE_NAV_ITEM,
} from './constants';

const initialState = {
  isPayerOpen: false,
  isProviderOpen: false,
  isMyAccountOpen: false,
  isNavItemOpen: false,
};

export const headerMenuReducer = createReducer(initialState, {
  [TOGGLE_PAYER]: (state, action) => {
    return {
      isPayerOpen: action.payload,
    };
  },

  [TOGGLE_PROVIDER]: (state, action) => {
    return {
      isProviderOpen: action.payload,
    };
  },

  [TOGGLE_MY_ACCOUNT]: (state, action) => {
    return {
      isMyAccountOpen: action.payload,
    };
  },
  [TOGGLE_NAV_ITEM]: (state, action) => {
    return {
      isNavItemOpen: action.payload,
    };
  },
});
